import { render, staticRenderFns } from "./DeskLeftView.vue?vue&type=template&id=79500cdf"
import script from "./DeskLeftView.vue?vue&type=script&lang=js"
export * from "./DeskLeftView.vue?vue&type=script&lang=js"
import style0 from "./DeskLeftView.vue?vue&type=style&index=0&id=79500cdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports